module.exports = __webpack_public_path__ + "static/media/background.5ef67839.svg";